type GetConfigT = {
  FLAGS: Record<string, boolean>;
  AUTH: {
    auth0Domain: string;
    auth0ClientId: string;
    auth0RedirectUrl: string;
    auth0Audience: string;
    googleAppId: string;
    azureAppId: string;
  };
  API: {
    url: string;
    ws: string;
    public_ws: string;
  };
  DETECT: {
    url: string;
    envId: string;
    apiKey: string;
  };
};

export const getConfig = (): GetConfigT => ({
  FLAGS: {
    wsEventDriven: Boolean(window.WS_EVENT_DRIVEN),
  },
  AUTH: {
    auth0Domain: window.AUTH0_DOMAIN,
    auth0ClientId: window.AUTH0_CLIENT_ID,
    auth0RedirectUrl: window.AUTH0_CALLBACK_URL,
    auth0Audience: window.AUTH0_AUDIENCE,
    googleAppId: window.GOOGLE_APP_ID,
    azureAppId: window.AZURE_APP_ID,
  },
  API: {
    url: window.API_URL || 'https://api-us1.dev.meeting.pindrop.com',
    ws: window.WS_API_URL || 'ws-us1.dev.meeting.pindrop.com',
    public_ws:
      window.PUBLIC_WS_API_URL || 'public-ws-us1.dev.meeting.pindrop.com',
  },
  DETECT: {
    url: window.DETECT_URL,
    envId: window.DETECT_ENV_ID,
    apiKey: window.DETECT_API_KEY,
  },
});
